export default {
    'SdnBhd': 0,
    'SolePartnerLlp': 1,
    'NewCompaniesAct': 2
};
